import { GetStaticProps } from 'next';
import React from 'react';

import CoreLayout from '@jpp/layouts/CoreLayout';
import Policy from '@jpp/templates/Policy';
import { SITE_DESCRIPTION } from 'common/utils/constants';

const ReturnPolicy: React.FunctionComponent = () => {
  const title = 'Return Policy';

  return (
    <CoreLayout title={title} description={SITE_DESCRIPTION}>
      <Policy id="ff279346-777e-4021-83a0-4b532122c294" title={title} />
    </CoreLayout>
  );
};

export const getStaticProps: GetStaticProps = async () => ({
  props: {},
});

export default ReturnPolicy;
